import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Lightweight client-side pager.
 * Usage:
 *   <Pager total={items.length} page={page} pageSize={30} onPage={setPage} testid="users-pager" />
 */
export default function Pager({ total, page, pageSize = 30, onPage, testid }) {
    const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
    if (pages <= 1) return null;
    const safePage = Math.min(Math.max(1, page), pages);
    const first = (safePage - 1) * pageSize + 1;
    const last = Math.min(safePage * pageSize, total);
    return (
        <div className="flex items-center justify-between py-3 px-1 text-sm" data-testid={testid}>
            <div className="text-muted-foreground">
                {first}–{last} sur {total}
            </div>
            <div className="flex items-center gap-1">
                <Button size="sm" variant="ghost" disabled={safePage <= 1} onClick={() => onPage(safePage - 1)} data-testid={`${testid}-prev`}>
                    <ChevronLeft size={14} /> Précédent
                </Button>
                <span className="px-3 text-xs text-muted-foreground">Page {safePage} / {pages}</span>
                <Button size="sm" variant="ghost" disabled={safePage >= pages} onClick={() => onPage(safePage + 1)} data-testid={`${testid}-next`}>
                    Suivant <ChevronRight size={14} />
                </Button>
            </div>
        </div>
    );
}
